import request from '@/utils/request'


// 查询用户银行卡信息列表
export function listBank(query) {
  return request({
    url: '/user/bank/list',
    method: 'get',
    params: query
  })
}

// 查询用户银行卡信息分页
export function pageBank(query) {
  return request({
    url: '/user/bank/page',
    method: 'get',
    params: query
  })
}

// 查询用户银行卡信息详细
export function getBank(data) {
  return request({
    url: '/user/bank/detail',
    method: 'get',
    params: data
  })
}

// 新增用户银行卡信息
export function addBank(data) {
  return request({
    url: '/user/bank/add',
    method: 'post',
    data: data
  })
}

// 修改用户银行卡信息
export function updateBank(data) {
  return request({
    url: '/user/bank/edit',
    method: 'post',
    data: data
  })
}

// 删除用户银行卡信息
export function delBank(data) {
  return request({
    url: '/user/bank/delete',
    method: 'post',
    data: data
  })
}
